import { request } from '../utils/request';

// 获取轮播图数据的请求函数
export function getCarousel(data) {
  return request({
    url: `/Carousel/getCarousel`,
    method: 'get',
    params: data
  });
}

export function access_token(data) {
  return request({
    url: `/sso/oauth2/token`,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json' // 确保请求头设置为 JSON
    },
  });
}

export function getuserinfo(data) {
  return request({
    url: `/sso/oauth2/userinfo`,
    method: 'get',
    params: data,
  });
}
